import React from "react";
import './index.css'

const CustomInputFile = ({title, Icon,getImgFile})=>{

    return(
        <div>
            <input onChange={e => getImgFile(e,'img')} className="input-file-selector" type="file" id="input-file-selector" />
            <label for='input-file-selector'>
                <div className="input-file-selector-button-section">
                    {Icon}
                    <p>{title}</p>
                </div>
            </label>
        </div>

    )

}

export default CustomInputFile